import ENSSelectLandPage from './ENSSelectLandPage.container'
export default ENSSelectLandPage
